export default "__VITE_ASSET__DO$Nvqn2__"